"use strict";

import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";

import moment from "moment";

import Section from "../../Template/Section";
import Row from "../../Layout/Row";
import Col from "../../Layout/Col";
import {filterContextToRequestParams, onFilterContextDidUpdate} from "../../../context/FilterContext/Util";

import {apiPath} from "../../../const";
import {getRequest} from "../../../service/api/request";
import VideoEnrichmentEventChart from "./VideoEnrichmentEventChart";
import Box from "../../Widget/Box";
import VideoEnrichmentAvgMinMaxChart from "./VideoEnrichmentAvgMinMaxChart";
import EnrichedVideoTable from "./EnrichedVideoTable";
import Tabs from "../../Widget/Tabs";

const VideoEnrichmentEventReport = withRouter(class VideoEnrichmentEventReport extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,

            avgDataEventReceivedToAvailability: "Loading...",
            minDataEventReceivedToAvailability: "Loading...",
            maxDataEventReceivedToAvailability: "Loading...",

            dataEventReceivedEventTimeSeries: [],
            enrichedEventTimeSeries: [],
            assetValidationEventTimeSeries: [],
            availableEventTimeSeries: [],
            assetValidationRetryEventTimeSeries: [],
            assetValidationRetryAbortEventTimeSeries: [],

            federatedEnrichedVideoEventTimeSeries: [],
            receivedFederatedEnrichedVideoEventTimeSeries: [],
            persistingFederatedEnrichedVideoEventTimeSeries: [],
            persistedFederatedEnrichedVideoEventTimeSeries: [],
            avgFederationEnrichedVideo: "Loading...",
            minFederationEnrichedVideo: "Loading...",
            maxFederationEnrichedVideo: "Loading...",
            avgPersistenceEnrichedVideo: "Loading...",
            minPersistenceEnrichedVideo: "Loading...",
            maxPersistenceEnrichedVideo: "Loading...",
            avgFederationPersistenceEnrichedVideo: "Loading...",
            minFederationPersistenceEnrichedVideo: "Loading...",
            maxFederationPersistenceEnrichedVideo: "Loading...",
            avgTotalFederationPersistenceEnrichedVideo: "Loading...",
            minTotalFederationPersistenceEnrichedVideo: "Loading...",
            maxTotalFederationPersistenceEnrichedVideo: "Loading...",


            federatedAgnosticCatalogueEventTimeSeries: [],
            receivedFederatedAgnosticCatalogueEventTimeSeries: [],
            persistingFederatedAgnosticCatalogueEventTimeSeries: [],
            persistedFederatedAgnosticCatalogueEventTimeSeries: [],
            avgFederationAgnosticCatalogue: "Loading...",
            minFederationAgnosticCatalogue: "Loading...",
            maxFederationAgnosticCatalogue: "Loading...",
            avgPersistenceAgnosticCatalogue: "Loading...",
            minPersistenceAgnosticCatalogue: "Loading...",
            maxPersistenceAgnosticCatalogue: "Loading...",
            avgFederationPersistenceAgnosticCatalogue: "Loading...",
            minFederationPersistenceAgnosticCatalogue: "Loading...",
            maxFederationPersistenceAgnosticCatalogue: "Loading...",
            avgTotalFederationPersistenceAgnosticCatalogue: "Loading...",
            minTotalFederationPersistenceAgnosticCatalogue: "Loading...",
            maxTotalFederationPersistenceAgnosticCatalogue: "Loading...",

            federationDurationEnrichedVideoTimeSeries: [],
            persistenceDurationEnrichedVideoTimeSeries: [],
            federationDurationAgnosticCatalogueTimeSeries: [],
            persistenceDurationAgnosticCatalogueTimeSeries: [],

            availabilityDistribution: [],
            mostProminentTimeWindow: "Loading...",

            loadingStatusReport: false,
            countEnrichingEnrichedVideos: 0,
            enrichingEnrichedVideos: [],
            countValidatingEnrichedVideos: 0,
            validatingEnrichedVideos: [],
            countFederatingEnrichedVideos: 0,
            federatingEnrichedVideos: [],
            countPersistingEnrichedVideos: 0,
            persistingEnrichedVideos: [],
            countFederatingAgnosticCatalogueEnrichedVideos: 0,
            federatingAgnosticCatalogueEnrichedVideos: [],
            countPersistingAgnosticCatalogueEnrichedVideos: 0,
            persistingAgnosticCatalogueEnrichedVideos: [],

            defaultPageSize: 20,
            defaultSorted: [{id: "lastModifiedDate", desc: true}],
            defaultSortDesc: true,
        };
    }

    componentWillMount() {
        this.fetchEnrichmentEventReport();
        this.fetchEnrichmentEventEnrichedVideoReport();
        this.fetchEnrichmentEventAgnosticCatalogueReport();
        this.fetchEnrichmentEventDataTimerHandle = 0;
        this.fetchEnrichmentEventEnrichedVideoDataTimerHandle = 0;
        this.fetchEnrichmentEventAgnosticCatalogueDataTimerHandle = 0;

        this.fetchStatusReport();
        this.fetchStatusDataTimerHandle = 0;
    }

    componentDidMount() {
        this.fetchEnrichmentEventDataTimerHandle =
            setInterval(() => this.fetchEnrichmentEventReport(), 300000);

        this.fetchEnrichmentEventEnrichedVideoDataTimerHandle =
            setInterval(() => this.fetchEnrichmentEventEnrichedVideoReport(), 300000);

        this.fetchEnrichmentEventAgnosticCatalogueDataTimerHandle =
            setInterval(() => this.fetchEnrichmentEventAgnosticCatalogueReport(), 300000);

        this.fetchStatusDataTimerHandle =
            setInterval(() => {
                this.fetchStatusReport();
            }, 60000);
    }

    componentWillUnmount() {
        clearInterval(this.fetchEnrichmentEventDataTimerHandle);
        clearInterval(this.fetchEnrichmentEventEnrichedVideoDataTimerHandle);
        clearInterval(this.fetchEnrichmentEventAgnosticCatalogueDataTimerHandle);
        clearInterval(this.fetchStatusDataTimerHandle);
    }

    componentDidUpdate(prevProps, prevState) {
        onFilterContextDidUpdate(prevProps.filterContext,
            this.props.filterContext,
            () => {
                this.fetchEnrichmentEventReport();
                this.fetchEnrichmentEventEnrichedVideoReport();
                this.fetchEnrichmentEventAgnosticCatalogueReport();
                this.fetchStatusReport();
            });
    }

    fetchEnrichmentEventReport() {
        const { loading } = this.state;

        if (loading) return;

        this.setState({ loading: true });

        const reportApiPath = apiPath + "/videoEnrichmentEvents/search/generateEnrichmentSummaryReport";

        let params = filterContextToRequestParams(this.props.filterContext);

        getRequest(
            reportApiPath,
            params
        )
            .then(response => {
                const avgDataEventReceivedToAvailability = this.humanizeDuration(response.entity.avgDataEventReceivedToAvailability);
                const minDataEventReceivedToAvailability = this.humanizeDuration(response.entity.minDataEventReceivedToAvailability);
                const maxDataEventReceivedToAvailability = this.humanizeDuration(response.entity.maxDataEventReceivedToAvailability);

                const dataEventReceivedEventTimeSeries = response.entity.dataEventReceivedEventTimeSeries || [];
                const enrichedEventTimeSeries = response.entity.enrichedEventTimeSeries || [];
                const assetValidationEventTimeSeries = response.entity.assetValidationEventTimeSeries || [];
                const availableEventTimeSeries = response.entity.availableEventTimeSeries || [];
                const assetValidationRetryEventTimeSeries = response.entity.assetValidationRetryEventTimeSeries || [];
                const assetValidationRetryAbortEventTimeSeries = response.entity.assetValidationRetryAbortEventTimeSeries || [];

                const availabilityDistribution =
                    (response.entity.availabilityTimeWindows || [])
                        .map(timeWindow => {
                            return [timeWindow.label, timeWindow.count];
                        });
                const mostProminentTimeWindow = (response.entity.mostProminentTimeWindow && response.entity.mostProminentTimeWindow.description) || '';

                this.setState({
                    avgDataEventReceivedToAvailability,
                    minDataEventReceivedToAvailability,
                    maxDataEventReceivedToAvailability,

                    dataEventReceivedEventTimeSeries,
                    enrichedEventTimeSeries,
                    assetValidationEventTimeSeries,
                    availableEventTimeSeries,
                    assetValidationRetryEventTimeSeries,
                    assetValidationRetryAbortEventTimeSeries,

                    availabilityDistribution,
                    mostProminentTimeWindow,
                });
            })
            .catch(reason => {

            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    fetchEnrichmentEventEnrichedVideoReport() {
        const { loading } = this.state;

        if (loading) return;

        this.setState({ loading: true });

        const reportApiPath = apiPath + "/videoEnrichmentEvents/search/generateFederatedEnrichedVideoSummaryReport";

        let params = filterContextToRequestParams(this.props.filterContext);

        getRequest(
            reportApiPath,
            params
        )
            .then(response => {
                const federatedEnrichedVideoEventTimeSeries = response.entity.federatedEnrichedVideoEventTimeSeries || [];
                const receivedFederatedEnrichedVideoEventTimeSeries = response.entity.receivedFederatedEnrichedVideoEventTimeSeries || [];
                const persistingFederatedEnrichedVideoEventTimeSeries = response.entity.persistingFederatedEnrichedVideoEventTimeSeries || [];
                const persistedFederatedEnrichedVideoEventTimeSeries = response.entity.persistedFederatedEnrichedVideoEventTimeSeries || [];
                const avgFederationEnrichedVideo = this.humanizeDuration(response.entity.avgFederationEnrichedVideo);
                const minFederationEnrichedVideo = this.humanizeDuration(response.entity.minFederationEnrichedVideo);
                const maxFederationEnrichedVideo = this.humanizeDuration(response.entity.maxFederationEnrichedVideo);
                const avgPersistenceEnrichedVideo = this.humanizeDuration(response.entity.avgPersistenceEnrichedVideo);
                const minPersistenceEnrichedVideo = this.humanizeDuration(response.entity.minPersistenceEnrichedVideo);
                const maxPersistenceEnrichedVideo = this.humanizeDuration(response.entity.maxPersistenceEnrichedVideo);
                const avgFederationPersistenceEnrichedVideo = this.humanizeDuration(response.entity.avgFederationPersistenceEnrichedVideo);
                const minFederationPersistenceEnrichedVideo = this.humanizeDuration(response.entity.minFederationPersistenceEnrichedVideo);
                const maxFederationPersistenceEnrichedVideo = this.humanizeDuration(response.entity.maxFederationPersistenceEnrichedVideo);
                const avgTotalFederationPersistenceEnrichedVideo = this.humanizeDuration(response.entity.avgTotalFederationPersistenceEnrichedVideo);
                const minTotalFederationPersistenceEnrichedVideo = this.humanizeDuration(response.entity.minTotalFederationPersistenceEnrichedVideo);
                const maxTotalFederationPersistenceEnrichedVideo = this.humanizeDuration(response.entity.maxTotalFederationPersistenceEnrichedVideo);

                const federationDurationEnrichedVideoTimeSeries = response.entity.federationDurationEnrichedVideoTimeSeries || [];
                const persistenceDurationEnrichedVideoTimeSeries = response.entity.persistenceDurationEnrichedVideoTimeSeries || [];

                this.setState({
                    federatedEnrichedVideoEventTimeSeries,
                    receivedFederatedEnrichedVideoEventTimeSeries,
                    persistingFederatedEnrichedVideoEventTimeSeries,
                    persistedFederatedEnrichedVideoEventTimeSeries,
                    avgFederationEnrichedVideo,
                    minFederationEnrichedVideo,
                    maxFederationEnrichedVideo,
                    avgPersistenceEnrichedVideo,
                    minPersistenceEnrichedVideo,
                    maxPersistenceEnrichedVideo,
                    avgFederationPersistenceEnrichedVideo,
                    minFederationPersistenceEnrichedVideo,
                    maxFederationPersistenceEnrichedVideo,
                    avgTotalFederationPersistenceEnrichedVideo,
                    minTotalFederationPersistenceEnrichedVideo,
                    maxTotalFederationPersistenceEnrichedVideo,

                    federationDurationEnrichedVideoTimeSeries,
                    persistenceDurationEnrichedVideoTimeSeries,
                });
            })
            .catch(reason => {

            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    fetchEnrichmentEventAgnosticCatalogueReport() {
        const { loading } = this.state;

        if (loading) return;

        this.setState({ loading: true });

        const reportApiPath = apiPath + "/videoEnrichmentEvents/search/generateFederatedAgnosticCatalogueSummaryReport";

        let params = filterContextToRequestParams(this.props.filterContext);

        getRequest(
            reportApiPath,
            params
        )
            .then(response => {
                const federatedAgnosticCatalogueEventTimeSeries = response.entity.federatedAgnosticCatalogueEventTimeSeries || [];
                const receivedFederatedAgnosticCatalogueEventTimeSeries = response.entity.receivedFederatedAgnosticCatalogueEventTimeSeries || [];
                const persistingFederatedAgnosticCatalogueEventTimeSeries = response.entity.persistingFederatedAgnosticCatalogueEventTimeSeries || [];
                const persistedFederatedAgnosticCatalogueEventTimeSeries = response.entity.persistedFederatedAgnosticCatalogueEventTimeSeries || [];
                const avgFederationAgnosticCatalogue = this.humanizeDuration(response.entity.avgFederationAgnosticCatalogue);
                const minFederationAgnosticCatalogue = this.humanizeDuration(response.entity.minFederationAgnosticCatalogue);
                const maxFederationAgnosticCatalogue = this.humanizeDuration(response.entity.maxFederationAgnosticCatalogue);
                const avgPersistenceAgnosticCatalogue = this.humanizeDuration(response.entity.avgPersistenceAgnosticCatalogue);
                const minPersistenceAgnosticCatalogue = this.humanizeDuration(response.entity.minPersistenceAgnosticCatalogue);
                const maxPersistenceAgnosticCatalogue = this.humanizeDuration(response.entity.maxPersistenceAgnosticCatalogue);
                const avgFederationPersistenceAgnosticCatalogue = this.humanizeDuration(response.entity.avgFederationPersistenceAgnosticCatalogue);
                const minFederationPersistenceAgnosticCatalogue = this.humanizeDuration(response.entity.minFederationPersistenceAgnosticCatalogue);
                const maxFederationPersistenceAgnosticCatalogue = this.humanizeDuration(response.entity.maxFederationPersistenceAgnosticCatalogue);
                const avgTotalFederationPersistenceAgnosticCatalogue = this.humanizeDuration(response.entity.avgTotalFederationPersistenceAgnosticCatalogue);
                const minTotalFederationPersistenceAgnosticCatalogue = this.humanizeDuration(response.entity.minTotalFederationPersistenceAgnosticCatalogue);
                const maxTotalFederationPersistenceAgnosticCatalogue = this.humanizeDuration(response.entity.maxTotalFederationPersistenceAgnosticCatalogue);

                const federationDurationAgnosticCatalogueTimeSeries = response.entity.federationDurationAgnosticCatalogueTimeSeries || [];
                const persistenceDurationAgnosticCatalogueTimeSeries = response.entity.persistenceDurationAgnosticCatalogueTimeSeries || [];

                this.setState({
                    federatedAgnosticCatalogueEventTimeSeries,
                    receivedFederatedAgnosticCatalogueEventTimeSeries,
                    persistingFederatedAgnosticCatalogueEventTimeSeries,
                    persistedFederatedAgnosticCatalogueEventTimeSeries,
                    avgFederationAgnosticCatalogue,
                    minFederationAgnosticCatalogue,
                    maxFederationAgnosticCatalogue,
                    avgPersistenceAgnosticCatalogue,
                    minPersistenceAgnosticCatalogue,
                    maxPersistenceAgnosticCatalogue,
                    avgFederationPersistenceAgnosticCatalogue,
                    minFederationPersistenceAgnosticCatalogue,
                    maxFederationPersistenceAgnosticCatalogue,
                    avgTotalFederationPersistenceAgnosticCatalogue,
                    minTotalFederationPersistenceAgnosticCatalogue,
                    maxTotalFederationPersistenceAgnosticCatalogue,

                    federationDurationAgnosticCatalogueTimeSeries,
                    persistenceDurationAgnosticCatalogueTimeSeries,
                });
            })
            .catch(reason => {

            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    fetchStatusReport() {
        const { loadingStatusReport } = this.state;

        if (loadingStatusReport) return;

        this.setState({ loadingStatusReport: true });

        const reportApiPath = apiPath + "/enrichedVideoStatuses/search/generateStatusReport";

        let params = filterContextToRequestParams(this.props.filterContext);

        getRequest(
            reportApiPath,
            params
        )
            .then(response => {
                const countEnrichingEnrichedVideos = response.entity.countEnrichingEnrichedVideos || 0;
                const enrichingEnrichedVideos = response.entity.enrichingEnrichedVideos || [];

                const countValidatingEnrichedVideos = response.entity.countValidatingEnrichedVideos || 0;
                const validatingEnrichedVideos = response.entity.validatingEnrichedVideos || [];

                const countFederatingEnrichedVideos = response.entity.countFederatingEnrichedVideos || 0;
                const federatingEnrichedVideos = response.entity.federatingEnrichedVideos || [];

                const countPersistingEnrichedVideos = response.entity.countPersistingEnrichedVideos || 0;
                const persistingEnrichedVideos = response.entity.persistingEnrichedVideos || [];

                const countFederatingAgnosticCatalogueEnrichedVideos = response.entity.countFederatingAgnosticCatalogueEnrichedVideos || 0;
                const federatingAgnosticCatalogueEnrichedVideos = response.entity.federatingAgnosticCatalogueEnrichedVideos || [];

                const countPersistingAgnosticCatalogueEnrichedVideos = response.entity.countPersistingAgnosticCatalogueEnrichedVideos || 0;
                const persistingAgnosticCatalogueEnrichedVideos = response.entity.persistingAgnosticCatalogueEnrichedVideos || [];

                this.setState({
                    countEnrichingEnrichedVideos,
                    enrichingEnrichedVideos,

                    countValidatingEnrichedVideos,
                    validatingEnrichedVideos,

                    countFederatingEnrichedVideos,
                    federatingEnrichedVideos,

                    countPersistingEnrichedVideos,
                    persistingEnrichedVideos,

                    countFederatingAgnosticCatalogueEnrichedVideos,
                    federatingAgnosticCatalogueEnrichedVideos,

                    countPersistingAgnosticCatalogueEnrichedVideos,
                    persistingAgnosticCatalogueEnrichedVideos,
                });
            })
            .catch(reason => {

            })
            .finally(() => {
                this.setState({ loadingStatusReport: false });
            });
    }

    humanizeDuration(durationInMilliseconds) {
        if (!durationInMilliseconds) return "Not Available"

        if (durationInMilliseconds < 1000) return `${durationInMilliseconds} ms`

        if (durationInMilliseconds < 60000) return `${Math.ceil(durationInMilliseconds / 1000)} seconds`

        if (durationInMilliseconds < 120000) return moment.utc(durationInMilliseconds).format("mm:ss")

        return moment.duration(durationInMilliseconds).humanize()
    }

    renderStatusTabs(countEnrichingEnrichedVideos, enrichingEnrichedVideos,
                     countValidatingEnrichedVideos, validatingEnrichedVideos,
                     countFederatingEnrichedVideos, federatingEnrichedVideos,
                     countPersistingEnrichedVideos, persistingEnrichedVideos,
                     countFederatingAgnosticCatalogueEnrichedVideos, federatingAgnosticCatalogueEnrichedVideos,
                     countPersistingAgnosticCatalogueEnrichedVideos, persistingAgnosticCatalogueEnrichedVideos,
                     loadingStatusReport, defaultPageSize, defaultSorted, defaultSortDesc) {

        let tabs = {};

        tabs[`Enriching (${countEnrichingEnrichedVideos})`] = this.renderStatusTabPane(
            countEnrichingEnrichedVideos, enrichingEnrichedVideos, loadingStatusReport,
            defaultPageSize, defaultSorted, defaultSortDesc);

        tabs[`Validating (${countValidatingEnrichedVideos})`] = this.renderStatusTabPane(
            countValidatingEnrichedVideos, validatingEnrichedVideos, loadingStatusReport,
            defaultPageSize, defaultSorted, defaultSortDesc);

        tabs[`Federating (${countFederatingEnrichedVideos})`] = this.renderStatusTabPane(
            countFederatingEnrichedVideos, federatingEnrichedVideos, loadingStatusReport,
            defaultPageSize, defaultSorted, defaultSortDesc);

        tabs[`Persisting (${countPersistingEnrichedVideos})`] = this.renderStatusTabPane(
            countPersistingEnrichedVideos, persistingEnrichedVideos, loadingStatusReport,
            defaultPageSize, defaultSorted, defaultSortDesc);

        tabs[`Federating Agnostic Catalogues (${countFederatingAgnosticCatalogueEnrichedVideos})`] = this.renderStatusTabPane(
            countFederatingAgnosticCatalogueEnrichedVideos, federatingAgnosticCatalogueEnrichedVideos, loadingStatusReport,
            defaultPageSize, defaultSorted, defaultSortDesc);

        tabs[`Persisting Agnostic Catalogues (${countPersistingAgnosticCatalogueEnrichedVideos})`] = this.renderStatusTabPane(
            countPersistingAgnosticCatalogueEnrichedVideos, persistingAgnosticCatalogueEnrichedVideos, loadingStatusReport,
            defaultPageSize, defaultSorted, defaultSortDesc);

        return (
            <>
                <Section className="content-header">
                    <h1>Status</h1>
                </Section>
                <Section className="content">
                    <Tabs tabs={tabs} />
                </Section>
            </>
        );
    }

    renderStatusTabPane(count, data, loading, defaultPageSize, defaultSorted, defaultSortDesc) {
        return (
            <EnrichedVideoTable
                loading={loading}
                data={data || []}
                defaultPageSize={defaultPageSize}
                defaultSorted={defaultSorted}
                defaultSortDesc={defaultSortDesc}
            />
        );
    }

    render() {
        const {
            avgDataEventReceivedToAvailability,
            minDataEventReceivedToAvailability,
            maxDataEventReceivedToAvailability,

            dataEventReceivedEventTimeSeries,
            enrichedEventTimeSeries,
            assetValidationEventTimeSeries,
            availableEventTimeSeries,
            assetValidationRetryEventTimeSeries,
            assetValidationRetryAbortEventTimeSeries,

            federatedEnrichedVideoEventTimeSeries,
            receivedFederatedEnrichedVideoEventTimeSeries,
            persistingFederatedEnrichedVideoEventTimeSeries,
            persistedFederatedEnrichedVideoEventTimeSeries,
            avgFederationEnrichedVideo,
            minFederationEnrichedVideo,
            maxFederationEnrichedVideo,
            avgPersistenceEnrichedVideo,
            minPersistenceEnrichedVideo,
            maxPersistenceEnrichedVideo,
            avgFederationPersistenceEnrichedVideo,
            minFederationPersistenceEnrichedVideo,
            maxFederationPersistenceEnrichedVideo,
            avgTotalFederationPersistenceEnrichedVideo,
            minTotalFederationPersistenceEnrichedVideo,
            maxTotalFederationPersistenceEnrichedVideo,

            federatedAgnosticCatalogueEventTimeSeries,
            receivedFederatedAgnosticCatalogueEventTimeSeries,
            persistingFederatedAgnosticCatalogueEventTimeSeries,
            persistedFederatedAgnosticCatalogueEventTimeSeries,
            avgFederationAgnosticCatalogue,
            minFederationAgnosticCatalogue,
            maxFederationAgnosticCatalogue,
            avgPersistenceAgnosticCatalogue,
            minPersistenceAgnosticCatalogue,
            maxPersistenceAgnosticCatalogue,
            avgFederationPersistenceAgnosticCatalogue,
            minFederationPersistenceAgnosticCatalogue,
            maxFederationPersistenceAgnosticCatalogue,
            avgTotalFederationPersistenceAgnosticCatalogue,
            minTotalFederationPersistenceAgnosticCatalogue,
            maxTotalFederationPersistenceAgnosticCatalogue,

            federationDurationEnrichedVideoTimeSeries,
            persistenceDurationEnrichedVideoTimeSeries,
            federationDurationAgnosticCatalogueTimeSeries,
            persistenceDurationAgnosticCatalogueTimeSeries,

            availabilityDistribution,
            mostProminentTimeWindow,

            countEnrichingEnrichedVideos,
            enrichingEnrichedVideos,

            countValidatingEnrichedVideos,
            validatingEnrichedVideos,

            countFederatingEnrichedVideos,
            federatingEnrichedVideos,

            countPersistingEnrichedVideos,
            persistingEnrichedVideos,

            countFederatingAgnosticCatalogueEnrichedVideos,
            federatingAgnosticCatalogueEnrichedVideos,

            countPersistingAgnosticCatalogueEnrichedVideos,
            persistingAgnosticCatalogueEnrichedVideos,

            loadingStatusReport,

            defaultPageSize,
            defaultSorted,
            defaultSortDesc,

        } = this.state;

        return (
            <div>
                <Section className="content-header">
                    <h1>Metrics</h1>
                </Section>
                <Section className="content">
                    <Row>
                        <Col lg="3" sm="12" xs="12">
                            <div className="small-box bg-teal">
                                <div className="inner">
                                    <p>Most Items Available Within</p>
                                    <h3>{mostProminentTimeWindow}</h3>
                                </div>
                            </div>
                        </Col>
                        <Col lg="3" sm="12" xs="12">
                            <div className="small-box bg-aqua">
                                <div className="inner">
                                    <h3>{avgDataEventReceivedToAvailability}</h3>
                                    <p>Average Time to Catalogue Availability</p>
                                </div>
                            </div>
                        </Col>
                        <Col lg="3" sm="12" xs="12">
                            <div className="small-box bg-green">
                                <div className="inner">
                                    <h3>{minDataEventReceivedToAvailability}</h3>
                                    <p>Shortest Time to Catalogue Availability</p>
                                </div>
                            </div>
                        </Col>
                        <Col lg="3" sm="12" xs="12">
                            <div className="small-box bg-red">
                                <div className="inner">
                                    <h3>{maxDataEventReceivedToAvailability}</h3>
                                    <p>Longest Time to Catalogue Availability</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12" sm="12" xs="12">
                            <Box header="Availability Distribution"
                                 content={
                                     <VideoEnrichmentEventChart
                                         eventChartId="availabilityDistribution"
                                         options={{
                                             grid: {
                                                 borderWidth: { top: 0, right: 0, bottom: 1, left: 0 },
                                                 markings: {xaxis: [], yaxes: []},
                                             },
                                             xaxis: {
                                                 mode: "categories",
                                                 showTicks: false,
                                                 gridLines: false,
                                             },
                                             // yaxis: {
                                             //     mode: "log",
                                             //     showTickLabels: "all"
                                             // },
                                             series: {
                                                 color: "#008d4c",
                                                 bars: {
                                                     show: true,
                                                     align: "right"
                                                 },
                                             },
                                         }}
                                         data={availabilityDistribution}
                                     />
                                 }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6" sm="12" xs="12">
                            <Box header="Data Events"
                                 content={
                                    <VideoEnrichmentEventChart
                                        eventChartId="dataEventReceivedEventTimeSeries"
                                        data={dataEventReceivedEventTimeSeries}
                                        color="#357ca5"
                                    />
                                }
                            />
                        </Col>
                        <Col lg="6" sm="12" xs="12">
                            <Box header="Enrichment"
                                 content={
                                     <VideoEnrichmentEventChart
                                         eventChartId="enrichedEventTimeSeries"
                                         data={enrichedEventTimeSeries}
                                         color="#00a7d0"
                                     />
                                 }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6" sm="12" xs="12">
                            <Box header="Validation"
                                 content={
                                     <VideoEnrichmentEventChart
                                         eventChartId="assetValidationEventTimeSeries"
                                         data={assetValidationEventTimeSeries}
                                         color="#30bbbb"
                                     />
                                 }
                            />
                        </Col>
                        <Col lg="6" sm="12" xs="12">
                            <Box header="Availability"
                                 content={
                                     <VideoEnrichmentEventChart
                                         eventChartId="availableEventTimeSeries"
                                         data={availableEventTimeSeries}
                                         color="#008d4c"
                                     />
                                 }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6" sm="12" xs="12">
                            <Box header="Asset Validation Retries"
                                 content={
                                     <VideoEnrichmentEventChart
                                         eventChartId="assetValidationRetryEventTimeSeries"
                                         data={assetValidationRetryEventTimeSeries}
                                         color="#db8b0b"
                                     />
                                 }
                            />
                        </Col>
                        <Col lg="6" sm="12" xs="12">
                            <Box header="Asset Validation Retries Aborted"
                                 content={
                                     <VideoEnrichmentEventChart
                                         eventChartId="assetValidationRetryAbortEventTimeSeries"
                                         data={assetValidationRetryAbortEventTimeSeries}
                                         color="#d33724"
                                     />
                                 }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6" sm="12" xs="12">
                            <Box header="Federated Scheduled Enriched Videos"
                                 content={
                                     <>
                                         <Row>
                                             <Col lg="4" sm="12" xs="12">
                                                 <div className="small-box bg-aqua">
                                                     <div className="inner">
                                                         <h3>{avgFederationEnrichedVideo}</h3>
                                                         <p>Average Federation Time</p>
                                                     </div>
                                                 </div>
                                             </Col>
                                             <Col lg="4" sm="12" xs="12">
                                                 <div className="small-box bg-green">
                                                     <div className="inner">
                                                         <h3>{minFederationEnrichedVideo}</h3>
                                                         <p>Shortest Federation Time</p>
                                                     </div>
                                                 </div>
                                             </Col>
                                             <Col lg="4" sm="12" xs="12">
                                                 <div className="small-box bg-red">
                                                     <div className="inner">
                                                         <h3>{maxFederationEnrichedVideo}</h3>
                                                         <p>Longest Federation Time</p>
                                                     </div>
                                                 </div>
                                             </Col>
                                         </Row>
                                         <Row>
                                             <Col lg="4" sm="12" xs="12">
                                                 <div className="small-box bg-aqua">
                                                     <div className="inner">
                                                         <h3>{avgPersistenceEnrichedVideo}</h3>
                                                         <p>Average Persistence Time</p>
                                                     </div>
                                                 </div>
                                             </Col>
                                             <Col lg="4" sm="12" xs="12">
                                                 <div className="small-box bg-green">
                                                     <div className="inner">
                                                         <h3>{minPersistenceEnrichedVideo}</h3>
                                                         <p>Shortest Persistence Time</p>
                                                     </div>
                                                 </div>
                                             </Col>
                                             <Col lg="4" sm="12" xs="12">
                                                 <div className="small-box bg-red">
                                                     <div className="inner">
                                                         <h3>{maxPersistenceEnrichedVideo}</h3>
                                                         <p>Longest Persistence Time</p>
                                                     </div>
                                                 </div>
                                             </Col>
                                         </Row>
                                         <Row>
                                             <Col lg="4" sm="12" xs="12">
                                                 <div className="small-box bg-aqua">
                                                     <div className="inner">
                                                         <h3>{avgFederationPersistenceEnrichedVideo}</h3>
                                                         <p>Average Federation / Persistence Time</p>
                                                     </div>
                                                 </div>
                                             </Col>
                                             <Col lg="4" sm="12" xs="12">
                                                 <div className="small-box bg-green">
                                                     <div className="inner">
                                                         <h3>{minFederationPersistenceEnrichedVideo}</h3>
                                                         <p>Shortest Federation / Persistence Time</p>
                                                     </div>
                                                 </div>
                                             </Col>
                                             <Col lg="4" sm="12" xs="12">
                                                 <div className="small-box bg-red">
                                                     <div className="inner">
                                                         <h3>{maxFederationPersistenceEnrichedVideo}</h3>
                                                         <p>Longest Federation / Persistence Time</p>
                                                     </div>
                                                 </div>
                                             </Col>
                                         </Row>
                                         <Row>
                                             <Col lg="4" sm="12" xs="12">
                                                 <div className="small-box bg-aqua">
                                                     <div className="inner">
                                                         <h3>{avgTotalFederationPersistenceEnrichedVideo}</h3>
                                                         <p>Average Total Enrichment / Federation / Persistence Time</p>
                                                     </div>
                                                 </div>
                                             </Col>
                                             <Col lg="4" sm="12" xs="12">
                                                 <div className="small-box bg-green">
                                                     <div className="inner">
                                                         <h3>{minTotalFederationPersistenceEnrichedVideo}</h3>
                                                         <p>Shortest Total Enrichment / Federation / Persistence Time</p>
                                                     </div>
                                                 </div>
                                             </Col>
                                             <Col lg="4" sm="12" xs="12">
                                                 <div className="small-box bg-red">
                                                     <div className="inner">
                                                         <h3>{maxTotalFederationPersistenceEnrichedVideo}</h3>
                                                         <p>Longest Total Enrichment / Federation / Persistence Time</p>
                                                     </div>
                                                 </div>
                                             </Col>
                                         </Row>
                                     </>
                                 }
                            />
                            <Box header="Federation of Scheduled Enriched Videos"
                                 content={
                                     <VideoEnrichmentAvgMinMaxChart
                                         eventChartId="federationDurationEnrichedVideoTimeSeries"
                                         data={federationDurationEnrichedVideoTimeSeries}
                                     />
                                 }
                            />
                            <Box header="Persistence of Scheduled Enriched Videos"
                                 content={
                                     <VideoEnrichmentAvgMinMaxChart
                                         eventChartId="persistenceDurationEnrichedVideoTimeSeries"
                                         data={persistenceDurationEnrichedVideoTimeSeries}
                                     />
                                 }
                            />
                            <Box header="Federated Scheduled Enriched Videos"
                                 content={
                                     <VideoEnrichmentEventChart
                                         eventChartId="federatedEnrichedVideoEventTimeSeries"
                                         data={federatedEnrichedVideoEventTimeSeries}
                                         color="#357ca5"
                                     />
                                 }
                            />
                            <Box header="Received Federated Scheduled Enriched Videos"
                                 content={
                                     <VideoEnrichmentEventChart
                                         eventChartId="receivedFederatedEnrichedVideoEventTimeSeries"
                                         data={receivedFederatedEnrichedVideoEventTimeSeries}
                                         color="#00a7d0"
                                     />
                                 }
                            />
                            <Box header="Persisting Federated Scheduled Enriched Videos"
                                 content={
                                     <VideoEnrichmentEventChart
                                         eventChartId="persistingFederatedEnrichedVideoEventTimeSeries"
                                         data={persistingFederatedEnrichedVideoEventTimeSeries}
                                         color="#db8b0b"
                                     />
                                 }
                            />
                            <Box header="Persisted Federated Scheduled Enriched Videos"
                                 content={
                                     <VideoEnrichmentEventChart
                                         eventChartId="persistedFederatedEnrichedVideoEventTimeSeries"
                                         data={persistedFederatedEnrichedVideoEventTimeSeries}
                                         color="#008d4c"
                                     />
                                 }
                            />
                        </Col>
                        <Col lg="6" sm="12" xs="12">
                            <Box header="Federated Scheduled Agnostic Catalogues"
                                 content={
                                <>
                                    <Row>
                                        <Col lg="4" sm="12" xs="12">
                                            <div className="small-box bg-aqua">
                                                <div className="inner">
                                                    <h3>{avgFederationAgnosticCatalogue}</h3>
                                                    <p>Average Federation Time</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg="4" sm="12" xs="12">
                                            <div className="small-box bg-green">
                                                <div className="inner">
                                                    <h3>{minFederationAgnosticCatalogue}</h3>
                                                    <p>Shortest Federation Time</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg="4" sm="12" xs="12">
                                            <div className="small-box bg-red">
                                                <div className="inner">
                                                    <h3>{maxFederationAgnosticCatalogue}</h3>
                                                    <p>Longest Federation Time</p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="4" sm="12" xs="12">
                                            <div className="small-box bg-aqua">
                                                <div className="inner">
                                                    <h3>{avgPersistenceAgnosticCatalogue}</h3>
                                                    <p>Average Persistence Time</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg="4" sm="12" xs="12">
                                            <div className="small-box bg-green">
                                                <div className="inner">
                                                    <h3>{minPersistenceAgnosticCatalogue}</h3>
                                                    <p>Shortest Persistence Time</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg="4" sm="12" xs="12">
                                            <div className="small-box bg-red">
                                                <div className="inner">
                                                    <h3>{maxPersistenceAgnosticCatalogue}</h3>
                                                    <p>Longest Persistence Time</p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="4" sm="12" xs="12">
                                            <div className="small-box bg-aqua">
                                                <div className="inner">
                                                    <h3>{avgFederationPersistenceAgnosticCatalogue}</h3>
                                                    <p>Average Federation / Persistence Time</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg="4" sm="12" xs="12">
                                            <div className="small-box bg-green">
                                                <div className="inner">
                                                    <h3>{minFederationPersistenceAgnosticCatalogue}</h3>
                                                    <p>Shortest Federation / Persistence Time</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg="4" sm="12" xs="12">
                                            <div className="small-box bg-red">
                                                <div className="inner">
                                                    <h3>{maxFederationPersistenceAgnosticCatalogue}</h3>
                                                    <p>Longest Federation / Persistence Time</p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="4" sm="12" xs="12">
                                            <div className="small-box bg-aqua">
                                                <div className="inner">
                                                    <h3>{avgTotalFederationPersistenceAgnosticCatalogue}</h3>
                                                    <p>Average Total Enrichment / Federation / Persistence Time</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg="4" sm="12" xs="12">
                                            <div className="small-box bg-green">
                                                <div className="inner">
                                                    <h3>{minTotalFederationPersistenceAgnosticCatalogue}</h3>
                                                    <p>Shortest Total Enrichment / Federation / Persistence Time</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg="4" sm="12" xs="12">
                                            <div className="small-box bg-red">
                                                <div className="inner">
                                                    <h3>{maxTotalFederationPersistenceAgnosticCatalogue}</h3>
                                                    <p>Longest Total Enrichment / Federation / Persistence Time</p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                                }
                            />
                            <Box header="Federation of Scheduled Agnostic Catalogues"
                                 content={
                                     <VideoEnrichmentAvgMinMaxChart
                                         eventChartId="federationDurationAgnosticCatalogueTimeSeries"
                                         data={federationDurationAgnosticCatalogueTimeSeries}
                                     />
                                 }
                            />
                            <Box header="Persistence of Scheduled Agnostic Catalogues"
                                 content={
                                     <VideoEnrichmentAvgMinMaxChart
                                         eventChartId="persistenceDurationAgnosticCatalogueTimeSeries"
                                         data={persistenceDurationAgnosticCatalogueTimeSeries}
                                     />
                                 }
                            />
                            <Box header="Federated Scheduled Agnostic Catalogues"
                                 content={
                                     <VideoEnrichmentEventChart
                                         eventChartId="federatedAgnosticCatalogueEventTimeSeries"
                                         data={federatedAgnosticCatalogueEventTimeSeries}
                                         color="#357ca5"
                                     />
                                 }
                            />
                            <Box header="Received Federated Scheduled Agnostic Catalogues"
                                 content={
                                     <VideoEnrichmentEventChart
                                         eventChartId="receivedFederatedAgnosticCatalogueEventTimeSeries"
                                         data={receivedFederatedAgnosticCatalogueEventTimeSeries}
                                         color="#00a7d0"
                                     />
                                 }
                            />
                            <Box header="Persisting Federated Scheduled Agnostic Catalogues"
                                 content={
                                     <VideoEnrichmentEventChart
                                         eventChartId="persistingFederatedAgnosticCatalogueEventTimeSeries"
                                         data={persistingFederatedAgnosticCatalogueEventTimeSeries}
                                         color="#db8b0b"
                                     />
                                 }
                            />
                            <Box header="Persisted Federated Scheduled Agnostic Catalogues"
                                 content={
                                     <VideoEnrichmentEventChart
                                         eventChartId="persistedFederatedAgnosticCatalogueEventTimeSeries"
                                         data={persistedFederatedAgnosticCatalogueEventTimeSeries}
                                         color="#008d4c"
                                     />
                                 }
                            />
                        </Col>
                    </Row>
                </Section>
                <>
                    {
                        this.renderStatusTabs(
                            countEnrichingEnrichedVideos, enrichingEnrichedVideos,
                            countValidatingEnrichedVideos, validatingEnrichedVideos,
                            countFederatingEnrichedVideos, federatingEnrichedVideos,
                            countPersistingEnrichedVideos, persistingEnrichedVideos,
                            countFederatingAgnosticCatalogueEnrichedVideos, federatingAgnosticCatalogueEnrichedVideos,
                            countPersistingAgnosticCatalogueEnrichedVideos, persistingAgnosticCatalogueEnrichedVideos,
                            loadingStatusReport, defaultPageSize, defaultSorted, defaultSortDesc
                        )
                    }
                </>
            </div>
        )
    }
});

export default VideoEnrichmentEventReport;
